export default "__VITE_ASSET__DHdo7alR__"